import {IRequestCommand} from 'app/services/authentication/connection/iRequestCommand';
import {IContractorEmployeeRequestDto, ErrorDetails} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import {CommandRequestType} from 'app/services/authentication/connection/commandRequestType';
import {ICommandParameters} from 'app/services/authentication/connection/iCommandParameters';
import {ICommandResponse} from 'app/services/authentication/connection/iCommandResponse';

export class DeleteContractorAreaCommand extends IRequestCommand<IUpdateContractorAreaResponse, ErrorDetails, IUpdateContractorAreaCommandRequest> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;

  public setId(contractorid: number, areaid: number) {
    this.urlSections.push('contractorsAreas');
    this.urlSections.push(`${contractorid}`);
    this.urlSections.push('delete');
    this.urlSections.push(`${areaid}`);
    this.composeUrl();
  }
}

export interface IUpdateContractorAreaCommandRequest extends IContractorEmployeeRequestDto,  ICommandParameters {

}

export interface IUpdateContractorAreaResponse extends ICommandResponse {
  id: number;
}
